import { initSubRoutes } from '../../../../utils/router';

const RoutesDemandeArmeHeritee = initSubRoutes({
    route: '/demande-arme-heritee',
    subroutes: {},
    nom: "Faire une demande d'arme héritée",
});

export default RoutesDemandeArmeHeritee;
